/**
 * Vitalura — salta il carrello.
 * Dopo un "aggiungi al carrello" riuscito dalla pagina prodotto, porta subito al checkout.
 * Non tocca gli aggiornamenti fatti dentro il carrello (quantità, rimozione).
 */
(function () {
  var redirecting = false;

  function goToCheckout() {
    if (redirecting) return;
    redirecting = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    window.location.href = root + 'checkout';
  }

  // Tema Horizon: il form prodotto emette cart:update con source 'product-form-component'.
  document.addEventListener('cart:update', function (event) {
    var data = (event && event.detail && event.detail.data) || {};
    if (data.didError) return;
    if (data.source !== 'product-form-component') return;
    goToCheckout();
  });
})();
